module.exports = __webpack_public_path__ + "img/main-sm.9d3b8789.jpg";